import {Pipe, PipeTransform} from "@angular/core";
import {FileNode} from "./clickatell-tree.interface";
import * as filteringTree from "./filteringTree";

@Pipe({
    name: 'filterTree'
})
export class FilterTreePipe implements PipeTransform {
    transform(value: FileNode[], searchString = ''): any {
        return filteringTree.filterTree(value, searchString)
    }

}